import { render, staticRenderFns } from "./homeDashboardGoalsStatistics.vue?vue&type=template&id=3297efb8&scoped=true"
import script from "./homeDashboardGoalsStatistics.vue?vue&type=script&lang=js"
export * from "./homeDashboardGoalsStatistics.vue?vue&type=script&lang=js"
import style0 from "./homeDashboardGoalsStatistics.vue?vue&type=style&index=0&id=3297efb8&prod&lang=css"
import style1 from "./homeDashboardGoalsStatistics.vue?vue&type=style&index=1&id=3297efb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3297efb8",
  null
  
)

export default component.exports